/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * Lists rebate claims
 */
function claimTransactionsDirective() {
    return {
        restrict: 'E',
        scope: {
            claimList: '<'
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: claimTransactionsController,
        template: require('./claimTransactionsView.html')
    };
}

claimTransactionsController.$inject = [
    '$window',
    'CmsContentService',
    'UtilService'
];
function claimTransactionsController (
    $window,
    CmsContentService,
    UtilService
) {
    this.$onInit = function () {
        const vm = this;

        vm.show_kit = false;
        vm.kit_text = "";

        CmsContentService.getMarketPlaceText(
            'account_page:rebates_section:rebates_section_kit_text')
            .then(function(text){
                vm.kit_text = text;
                if (text && text.length > 0){
                    vm.show_kit = true;
                }
        });

        /**
         * Create a class based on rebate status
         * @param {Object} rebate - Rebate object
         * @return {string} CSS class to be used in view, available CSS
         * classes are status-processing, status-accepted, status-rejected
         */
        vm.createStatusGroupCssClass = function(rebate) {
            const statusGroup = rebate.claims[0].status_group;
            return statusGroup ? `status-${statusGroup.toLowerCase()}` : "";
        }

        /**
         * Tango card (universal payment method) functionality
         */
        vm.isTangoEnabled = UtilService.isFeatureEnabled('tango_rewards');

        /**
         * Opens a new browser window with the Tango URL
         * @param {string} tangoUrl - URL to open
         */
        vm.openTango = function(tangoUrl) {
            $window.open(tangoUrl, '_blank');
        };
    }
}

module.exports = claimTransactionsDirective;
